<template>
  <div class="rt-kind">
    <div class="title">
      {{ title }}
    </div>
    <div
      ref="content"
      :class="{ more: showMore }"
      class="content"
    >
      <template v-if="!multiple">
        <template v-if="confirmTitle">
          <rt-popconfirm
            v-for="(item, index) in list"
            :key="index"
            :title="confirmTitle"
            @confirm="itemClick(item, index)"
          >
            <div
              slot="reference"
              :class="{ active: currentItem == index }"
              class="__item"
            >
              {{ item[alias.name] }}
            </div>
          </rt-popconfirm>
        </template>
        <template v-else-if="!confirmTitle">
          <div
            v-for="(item, index) in list"
            :key="index"
            :class="{ active: currentItem == index }"
            class="__item"
            @click="itemClick(item, index)"
          >
            {{ item[alias.name] }}
          </div>
        </template>
      </template>
      <template v-else>
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="{ active: isCheck(item) }"
          class="__item"
          @click="itemMultipleClick(item)"
        >
          {{ item[alias.name] }}
        </div>
      </template>
    </div>
    <div
      v-if="showBtn"
      class="operation"
    >
      <rt-button
        :suffix-icon="suffixIcon"
        background
        size="small"
        @click="showMoreClick"
      >
        {{ $tx('更多', 'xpc.common.more') }}
      </rt-button>
    </div>
  </div>
</template>

<script>
import RtPopconfirm from '../popconfirm/rtPopconfirm';
import RtButton from '../button/rtButton.vue';
import { store } from '../table/store';
const alias = { id: 'id', name: 'name' };
export default {
  name: 'RtKind',
  components: {
    RtPopconfirm,
    RtButton
  },
  props: {
    confirmTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    alias: {
      type: Object,
      default () {
        return alias;
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showMore: false,
      showBtn: false,
      active: false,
      initContentWidth: 0,
      currentItem: -1,
      multipleCheckList: [],
      state: store.state
    };
  },
  computed: {
    suffixIcon () {
      return this.showMore ? 'rt-base-arrow-up-lined' : 'rt-base-arrow-down-lined';
    },
    searchShowMore () {
      return store.state.showMore;
    }
  },
  watch: {
    value (value) {
      if (this.list && this.list.length > 0) {
        this.list.forEach((item, index) => {
          if (value === item) {
            this.currentItem = index;
          }
        });
      }
    },
    list (newValue) {
      this.contentWidth();
    },
    initContentWidth (newValue) {
      this.contentWidth();
    },
    searchShowMore (newValue) {
      this.contentWidth();
    }
  },
  mounted () {
    const fn = () => {
      return (() => {
        this.debounce(this.initContentWidthMethod, 800)();
      })();
    };
    window.addEventListener('resize', fn);

    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', fn);
    });
  },
  methods: {
    itemClick (item, index) {
      if (this.currentItem !== index) {
        this.currentItem = index;
        this.$emit('confirm', item);
      } else {
        this.currentItem = -1;
        this.$emit('confirm');
      }
    },
    itemMultipleClick (row) {
      let index = -1;
      for (let i = 0; i < this.multipleCheckList.length; i++) {
        if (this.multipleCheckList[i][this.alias.id] === row[this.alias.id]) {
          index = i;
          break;
        }
      }
      if (index >= 0) {
        this.multipleCheckList.splice(index, 1);
      } else {
        this.multipleCheckList.push(row);
      }
      this.$emit('confirm', this.multipleCheckList);
    },
    isCheck (row) {
      let isChecked = false;
      if (this.multipleCheckList) {
        this.multipleCheckList.map(item => {
          if (item[this.alias.id] === row[this.alias.id]) {
            isChecked = true;
          }
        });
      }
      return isChecked;
    },
    initContentWidthMethod () {
      this.initContentWidth = window.innerWidth;
    },
    showMoreClick () {
      this.showMore = !this.showMore;
    },
    contentWidth () {
      this.$nextTick(() => {
        let content = this.$refs.content;
        let contentWidth = this.$refs.content.offsetWidth;
        let listWidth = 0;
        let itemNodeList = content.querySelectorAll('.__item');
        let arr_item = Array.prototype.slice.call(itemNodeList);
        if (arr_item.length > 0) {
          arr_item.map(item => {
            listWidth += item.offsetWidth + 32;
          });
        }
        this.showBtn = listWidth > contentWidth - 48;
      });
    },
    debounce (fn, delay) {
      let timer = null;
      return function () {
        let context = this;
        let args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtKind.vue?4c22f7a7